import React from 'react';

const UserRegisterContent = () => {
  let companyOptions = [{ label: 'Company1' }, { label: 'Company2' }];

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="m-4">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  First Name <span className="text-danger">*</span>
                </label>
                <input placeholder="First Name" type="text" className="form-control" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Last Name <span className="text-danger">*</span>
                </label>

                <input placeholder="Last Name" type="text" className="form-control" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Date of Hire <span className="text-danger">*</span>
                </label>
                <input type="date" className="form-control" />
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Email <span className="text-danger">*</span>
                </label>
                <input type="email" className="form-control" placeholder="Email" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Phone <span className="text-danger">*</span>
                </label>
                <input type="text" className="form-control" placeholder="Phone" />
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Position <span className="text-danger">*</span>
                </label>
                <input type="text" className="form-control" placeholder="Position" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Address <span className="text-danger">*</span>
                </label>
                <input type="text" className="form-control" placeholder="Address" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Company <span className="text-danger">*</span>
                </label>
                <select className="form-control" required>
                  {companyOptions.map(option => (
                    <option key={option.label} value={option.label}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Login */}
        <div className="m-2">
          <h5 className="header-five">Login Access</h5>
          <div className="row m-2">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Role <span className="text-danger">*</span>
                </label>
                <input type="text" className="form-control" />
              </div>
            </div>

            <div className="col-lg-3 col-md-3 col-sm-12">
              <div className="input-blocks">
                <label>
                  Password <span className="text-danger">*</span>
                </label>
                <input type="password" className="form-control" />
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12">
              <div className="input-blocks">
                <label>
                  Confirm Password <span className="text-danger">*</span>
                </label>
                <input type="password" className="form-control" />
              </div>
            </div>
          </div>
        </div>
        <div className="m-2">
          <h5 className="header-five">Contact Address</h5>
          <div className="row m-2">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Address Line 1 <span className="text-danger">*</span>
                </label>
                <input type="text" className="form-control" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  City <span className="text-danger">*</span>
                </label>
                <input type="text" className="form-control" />
              </div>
            </div>
          </div>

          <div className="row m-2">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  State <span className="text-danger">*</span>
                </label>
                <input type="text" className="form-control" />
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>Zip Code </label>
                <input type="text" className="form-control" />
              </div>
            </div>
          </div>

          <h5 className="header-five"></h5>
          <div className="row m-2">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Account Status <span className="text-danger">*</span>
                </label>
                <input type="text" className="form-control" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-blocks">
                <label>
                  Pass Code <span className="text-danger">*</span>
                </label>
                <input type="text" className="form-control" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserRegisterContent;
